import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewControlPesoDiario = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'ctrl_peso_diario',
        name: 'Control Peso Diario',
        component: ViewControlPesoDiario,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
